<template>
  <div v-if="showBottom">
    <!-- <div class="phone-viewport"> -->
    <md-bottom-bar md-sync-route>
      <md-bottom-bar-item
        v-for="menu in menus"
        :key="menu.name"
        :to="menu.path"
        :md-label="menu.name"
        :md-icon="menu.icon"
      ></md-bottom-bar-item>
      <!-- <md-bottom-bar-item to="/microservices" md-label="Home" md-icon="home"></md-bottom-bar-item>
        <md-bottom-bar-item to="/servers" md-label="Posts" md-icon="home"></md-bottom-bar-item>
      <md-bottom-bar-item to="/clients" md-label="Favorites" md-icon="favorite"></md-bottom-bar-item>-->
    </md-bottom-bar>
    <!-- </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Shift",
  computed: {
    ...mapGetters({
      menus: "menus",
      isDetail: "isDetail",
      showBottom: "showBottom"
    })
  },
  methods: {
    addNew() {
      alert("as");
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 600px) {
  .md-bottom-bar {
    display: none;
  }
}
.md-bottom-bar {
  position: fixed;
  bottom: 0;
  z-index: 100;
}
.phone-viewport {
  width: 322px;
  height: 200px;
  display: inline-flex;
  align-items: flex-end;
  overflow: hidden;
  border: 1px solid rgba(#000, 0.26);
  background: rgba(#000, 0.06);
}
</style>